import { inject, injectable } from 'inversify-props';
import { IAppConfig, IAppConfigId } from '@/features/shared/IAppConfig';
import { AxiosId } from '@/plugins/axios';
import { AxiosInstance } from 'axios';
import { ILinesApi } from './ILinesApi';
import { Line } from './Line';
import { LineDto } from './LineDto';

@injectable()
export default class LinesApi implements ILinesApi {
    @inject(IAppConfigId)
    config!: IAppConfig;

    @inject(AxiosId)
    axios!: AxiosInstance;

    getLines(calendarDay: string): Promise<Line[]> {
        return new Promise((resolve, reject) => {
            this.axios
                .get<LineDto[]>('/api/lines/getlines', {
                    params: {
                        calendarDay: calendarDay,
                        token: this.config.token
                    }
                })
                .then(response => {
                    const lines: Line[] = response.data.map(
                        ({ name, number, transportType }: LineDto): Line => ({
                            name,
                            number,
                            transportType
                        })
                    );
                    resolve(lines);
                })
                .catch(exception => {
                    reject(exception);
                });
        });
    }
}
